<div class="map-container">
  <app-dna-syngovia-chart-map
    [systemDetails]="systemDetails"
    [dataConnections]="dataConnections"
    (selectedGroupNodeChange)="onSelectedGroupNodeChange($event)"
  ></app-dna-syngovia-chart-map>
</div>

<ng-container *ngIf="selectedGroupNode">
  <app-dna-syngovia-group-table-list
    id="syngovia-table-list"
    [groupNode]="selectedGroupNode"
  ></app-dna-syngovia-group-table-list>
</ng-container>
